var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-episode-transcript-tab"},[_c('form-editor',{model:{value:(_vm.transcript),callback:function ($$v) {_vm.transcript=$$v},expression:"transcript"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }